import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

export function getCommunityImageUrl(imageId: string): string {
	return createUrlRelativeToEnvironment(
		`/Hub/Communities/Image/?imageId=${encodeURIComponent(imageId)}`
	);
}
